import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";
import { AuthGuard } from "./_core/interceptors/auth-guard";
import { Policies } from "./_core/models/main/policies.enum";
import { AdminPageComponent } from "./modules/main/pages/admin/admin.page";
import { CebePageComponent } from "./modules/main/pages/cebe/cebe.page";
import { CentroPageComponent } from "./modules/main/pages/centro/centro.page";
import { HomeComponent } from "./modules/main/pages/home/home.page";
import { PowerbiComponent } from "./modules/main/pages/powerbi/powerbi.component";
import { ErrorComponent } from "./modules/shared/error/error.component";
import { LayoutComponent } from "./modules/shared/layout/layout.component";
import { NoPermissionsComponent } from "./modules/shared/no-permissions/no-permissions.component";
import { MapComponent } from "./modules/main/pages/map/map.component";

const routes: Routes = [
	{
		path: "",
		component: LayoutComponent,
		canActivate: [MsalGuard],
		children: [
			{
				path: "error",
				component: ErrorComponent,
			},
			{
				path: "no-permissions",
				component: NoPermissionsComponent,
			},
			{
				path: "home",
				component: HomeComponent,
				data: {
					policies: [Policies.Admin],
					breadcrumb: null,
					animation: "home",
				},
				canActivate: [MsalGuard, AuthGuard],
			},
			{
				path: "map",
				component: MapComponent,
				data: {
					policies: [Policies.Admin],
					breadcrumb: null,
				},
				canActivate: [MsalGuard, AuthGuard],
			},
			{
				path: "cebe/:cebe",
				component: CebePageComponent,
				data: {
					policies: [Policies.View_Cebe_Home],
				},
				canActivate: [MsalGuard, AuthGuard],
			},
			{
				path: "centro/create/:cebeId",
				component: CentroPageComponent,
				data: {
					policies: [Policies.View_Centro_Home],
				},
				canActivate: [MsalGuard, AuthGuard],
			},
			{
				path: "centro/:centroId",
				component: CentroPageComponent,
				data: {
					policies: [Policies.View_Centro_Home],
				},
				canActivate: [MsalGuard, AuthGuard],
			},
			{
				path: "admin",
				component: AdminPageComponent,
				data: {
					policies: [Policies.View_Admin_Home],
				},
				canActivate: [MsalGuard, AuthGuard],
			},
			{
				path: "powerbi",
				component: PowerbiComponent,
				data: {
					policies: [Policies.Admin],
					breadcrumb: null,
				},
				canActivate: [MsalGuard, AuthGuard],
			},
			{
				path: "opportunities",
				canActivate: [MsalGuard, AuthGuard],
				data: {
					policies: [Policies.Admin],
					breadcrumb: null,
				},
				loadChildren: () =>
					import("./modules/opportunities/opportunities.module").then(
						(m) => m.OpportunitiesModule,
					),
			},
			{
				path: "contracts",
				canActivate: [MsalGuard, AuthGuard],
				data: {
					policies: [Policies.Admin],
					breadcrumb: null,
				},
				loadChildren: () =>
					import("./modules/contracts/contracts.module").then(
						(m) => m.ContractsModule,
					),
			},
			{
				path: "contacts",
				canActivate: [MsalGuard, AuthGuard],
				data: {
					policies: [Policies.Admin],
					breadcrumb: null,
				},
				loadChildren: () =>
					import("./modules/contacts/contacts.module").then(
						(m) => m.ContactsModule,
					),
			},
			{
				path: "cebes",
				canActivate: [MsalGuard, AuthGuard],
				data: {
					policies: [Policies.Admin],
					breadcrumb: null,
				},
				loadChildren: () =>
					import("./modules/cebes/cebes.module").then(
						(m) => m.CebesModule,
					),
			},
			{
				path: "",
				redirectTo: "home",
				pathMatch: "full",
			},
			{
				path: "**",
				redirectTo: "home",
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [],
})
export class AppRoutingModule {}
